import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["components", "componentsProps"];
import * as React from 'react';
export function useProps(allProps) {
  return React.useMemo(() => {
    const {
        components,
        componentsProps
      } = allProps,
      themedProps = _objectWithoutPropertiesLoose(allProps, _excluded);
    return [components, componentsProps, themedProps];
  }, [allProps]);
}